import { render, staticRenderFns } from "./cjsw.vue?vue&type=template&id=9bad97cc&scoped=true&"
import script from "./cjsw.vue?vue&type=script&lang=js&"
export * from "./cjsw.vue?vue&type=script&lang=js&"
import style0 from "./cjsw.vue?vue&type=style&index=0&id=9bad97cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bad97cc",
  null
  
)

export default component.exports